import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Container, CardHeader, CardFooter, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import IButtonComponent from '../iComponents/iButton/IButton';
import { DownloadFile, DownloaFilesInZIP, getIconByExtension, isDisabledPreview, PreviewFile } from '../../../helpers/attachments_helper';
import { useDispatch, useSelector } from 'react-redux';
import { getAttachments, getOneAttachment } from '../../../store/attachments/actions';
import '../ShowAttachments/ShowAttachments.scss';
import Iloading from '../iComponents/iLoading/Iloading';
import Swal from 'sweetalert2';

const ShowAttachments = ({ GUID, type, Number, LayoutType }: any) => {
    const { attachmentList, isLoading, attachmentData, isLoadingBase64 } = useSelector((state: any) => state.Attachments);
    const dispatch = useDispatch();
    const [attachments, setAttachments] = useState<any>([]);
    const [selectedAttachment, setSelectedAttachment] = useState<any>('');
    const [base64Attachment, setbase64Attachment] = useState<any>('');
    const [cacheBase64Att, setcacheBase64Att] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [tabPurchaseView, setTabPurchaseView] = useState<string>("2");

    useEffect(() => {
        dispatch(getAttachments({ GUID, type, Number, LayoutType }));
    }, []);
    useEffect(() => {
        setAttachments(attachmentList);
    }, [attachmentList]);

    useEffect(() => {
        if (attachmentData) {
            setbase64Attachment(attachmentData);
            setcacheBase64Att([...cacheBase64Att, { ...attachmentData, isSelected: false }]);
        }
    }, [attachmentData]);

    useEffect(() => {
        if (selectedAttachment) {
            const { Identifier, ShipmentGUID, LayoutType} = selectedAttachment;
            const isExist = cacheBase64Att.find((obj: any) => obj.Identifier === Identifier);
            const typeItem = LayoutType == "Container" || LayoutType == "Item" ? "WI" : type;
            if (!isExist) {
                dispatch(getOneAttachment({ GUID: ShipmentGUID, type:typeItem, Identifier }));
            } else {
                setbase64Attachment(isExist);
            }
        }
    }, [selectedAttachment]);

    const handleSelectAttachment = (attachment: any) => {
        if (attachment.isValidSize) {
            setSelectedAttachment(attachment);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'The file is too big to get via API, please request it by email',
                showConfirmButton: true,
            })
        }
    };
    const handleDownload = () => {
        const Data = base64Attachment.Data;
        if (selectedAttachment && base64Attachment) DownloadFile({ ...selectedAttachment, Data });
    };
    const handlePreview = () => {
        const Data = base64Attachment.Data;
        if (selectedAttachment && base64Attachment) PreviewFile({ ...selectedAttachment, Data });
    };
    const handleDownloadZIP = async () => {
        const checkAttachments = attachments.filter((attachment: any) => attachment.isSelected);
        const filteredCacheBase64Att = cacheBase64Att
            .map((base64Attachment: any) => {
                const matchingAttachment = checkAttachments.find((attachment: any) => attachment.Identifier === base64Attachment.Identifier);
                if (matchingAttachment) {
                    return {
                        ...base64Attachment,
                        Extension: matchingAttachment.Extension,
                        Name: matchingAttachment.Name,
                        ShipmentNumber: matchingAttachment.ShipmentNumber
                    };
                }
                return null;
            })
            .filter((item: any) => item !== null);

        if (checkAttachments.length > 0) {
            await DownloaFilesInZIP(filteredCacheBase64Att, type, Number, 'attachments');
        }
    };
    const validIdenticator = (identifier: any) => {
        return identifier === selectedAttachment.Identifier;
    };
    const isDisabledButtonZIP = () => {
        const checkAttachments = attachments.filter((attachment: any) => attachment.isSelected);
        return checkAttachments.length === 0;
    };
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, Identifier: string) => {
        const isChecked = event.target.checked;
        const updatedAttachments = attachments.map((attachment: any) => {
            if (attachment.Identifier === Identifier) {
                return { ...attachment, isSelected: isChecked };
            }
            return attachment;
        });
        setAttachments(updatedAttachments);
    };
    const validateExistInCache = (Identifier: string) => {
        const isExist = cacheBase64Att.find((obj: any) => obj.Identifier === Identifier);
        if (isExist) return <i className="bx bx-down-arrow-circle" style={{ fontSize: '2.5rem' }}></i>;
    };
    const filteredAttachments = attachments.filter((attachment: any) => attachment.Name.toLowerCase().includes(searchTerm.toLowerCase()));

    const renderNav = ()=>{
        return (
            <Nav horizontal="end" tabs>
                {LayoutType == 'Master' ? (
                    <NavItem>
                        <NavLink className={`${tabPurchaseView === '1' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('1')}>
                            <i className="bi bi-info-circle pe-1"></i> Master
                        </NavLink>
                    </NavItem>
                ) : null}

                <NavItem>
                    <NavLink className={`${tabPurchaseView === '2' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('2')}>
                        <i className="bi bi-info-circle pe-1"></i> House
                    </NavLink>
                </NavItem>
                {/* <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '3' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('3')}
                >
                  <i className="bx bx-file-blank"></i> Container
                </NavLink>
              </NavItem> */}
                <NavItem>
                    <NavLink className={`${tabPurchaseView === '3' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('3')}>
                        <i className="dripicons-document"></i> Commodity
                    </NavLink>
                </NavItem>
            </Nav>
        );
    }


const renderContent = () => {
    if (type == 'SH') {
        return (
            <TabContent activeTab={tabPurchaseView}>
                <TabPane tabId="1">
                    {filteredAttachments.filter((item: any) => item.LayoutType === 'Master').map((item: any) => renderAttachment(item))}
                </TabPane>
                <TabPane tabId="2">
                    {filteredAttachments.filter((item: any) => item.LayoutType === 'House'|| item.LayoutType === 'Straight').map((item: any) => renderAttachment(item))}
                </TabPane>
                <TabPane tabId="3">
                    {filteredAttachments
                        .filter((item: any) => item.LayoutType === 'Item' || item.LayoutType === 'Container')
                        .map((item: any) => renderAttachment(item))}
                </TabPane>

                {/* <TabPane tabId="3">
                {filteredAttachments.filter((item: any) => item.LayoutType === 'Container').map((item: any) => renderAttachment(item))}
            </TabPane> */}
            </TabContent>
        );
    }else{
        return filteredAttachments.map((attachment: any) => renderAttachment(attachment));
    }
};

    const renderAttachment = (attachment: any) => {
        return (
            <div className={'container-attachments'}>
                <div
                    key={attachment.Identifier}
                    className={`attachment-item ${validIdenticator(attachment.Identifier) && 'selected-attachment'}`}
                    onClick={() => handleSelectAttachment(attachment)}
                >
                    <i className={getIconByExtension(attachment.Extension)}></i>
                    <span>
                        {attachment.Name} - {`${attachment?.LayoutType !== 'undefined' ? attachment.LayoutType + ' -' : ''}`}{' '}
                        {attachment.ShipmentNumber}
                    </span>
                    <div className="custom-checkbox">
                        {validateExistInCache(attachment.Identifier)}
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`formCheck-${attachment.Identifier}`}
                            aria-checked={attachment.isSelected}
                            disabled={attachment.isValidSize ? false : true}
                            onChange={(event: any) => handleCheckboxChange(event, attachment.Identifier)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Container>
            <div className="container-sm">
                <Iloading loading={isLoading} />
                <Iloading loading={isLoadingBase64} />
            </div>
            <Card className={'container-ShowAttachments'}>
                <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>
                        Attachments - {type} - {Number}
                    </h2>
                    <div className="search__container">
                        <input type="text" placeholder="Search..." value={searchTerm} onChange={handleSearchChange} className="search-input" />
                    </div>
                </CardHeader>
                <CardBody className={'container-ShowAttachmentsBody'}>
                    {type == "SH" ? renderNav():null}
                    {renderContent()}
                </CardBody>
                <CardFooter className='container_buttons_attachments'>
                    {attachments.length > 0 && (
                        <IButtonComponent
                            className="btn-search text-nowrap w-auto"
                            actionOnClick={() => handleDownloadZIP()}
                            label={`Download Checked`}
                            btnIcon="dripicons-folder-open"
                            disabled={isDisabledButtonZIP()}
                        ></IButtonComponent>
                    )}
                    {selectedAttachment && (
                        <div className='d-flex' style={{ marginLeft: 'auto' }}>
                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handleDownload()}
                                label={`Download`}
                                btnIcon="dripicons-download"
                            ></IButtonComponent>
                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handlePreview()}
                                label={`Preview`}
                                btnIcon="dripicons-preview"
                                disabled={isDisabledPreview(selectedAttachment.Extension)}
                            ></IButtonComponent>
                        </div>
                    )}
                </CardFooter>
            </Card>
        </Container>
    );
};

ShowAttachments.propTypes = {
    GUID: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    Number: PropTypes.string.isRequired,
    LayoutType: PropTypes.string.isRequired,
};

export default ShowAttachments;
